<mat-card class="mb-25 personal-info-card tagus-card">
  <mat-card-header class="border-bottom">
    <h5 class="mb-0">Comments</h5>
    <span class="gray-color align-right"></span>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="!hasData && !createComment">No comments to display</div>
    <div *ngIf="hasData">
      <div
        *ngFor="let comment of this.comments.data"
        class="row"
        style="padding-bottom: 15px"
      >
        <span class="fw-semibold d-inline-block">{{
          comment.createdAt | date : "long"
        }}</span>
        <span class="gray-color align-right">{{ comment.comment }}</span>
      </div>
    </div>
    <div *ngIf="createComment" class="row">
      <label class="d-block mb-12 fw-semibold gray-color">New Comment</label>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="newComment.comment" type="text" />
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <div class="text-end" style="padding: 30px">
      <button
        *ngIf="canEdit && !createComment"
        mat-flat-button
        (click)="addComment($event)"
        color="add-comment"
      >
        Add Comment
      </button>
      <button
        *ngIf="createComment"
        mat-flat-button
        (click)="cancelComment()"
        color="cancel"
      >
        Cancel
      </button>
      <button
        *ngIf="createComment"
        mat-flat-button
        (click)="saveComment()"
        color="add-comment"
      >
        Save Comment
      </button>
    </div>
  </mat-card-footer>
</mat-card>
